import React from 'react';
import {useTranslation} from 'react-i18next';
import {makeStyles, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,} from '@material-ui/core';
import ActionMenu, {Action} from '../../../components/ui/blocks/ActionMenu';
import {Row} from '../../../components/ui/blocks/DataTable';
import {UserWithRole} from '../../../types/User/UserWithRole';
import {User} from '../../../types/User/User';

const useStyles = makeStyles((theme) => ({
  even: {
    border: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
  },
  odd: {
    border: 'none',
    backgroundColor: theme.palette.background.default,
  },
}));

interface ActiveTeamTableProps {
  team: UserWithRole[];
  onAction?: (action: Action, row: UserWithRole) => void;
  user?: User;
}

export default function ActiveTeamTable({ team, onAction, user }: ActiveTeamTableProps) {
  const { t } = useTranslation(['company', 'global']);
  const classes = useStyles();

  const showNameColumn = team.some((item) => item.firstName !== null);

  const actions: Action[] = [
    { id: 'delete', label: t('global:delete') },
    { id: 'reset-password', label: t('company:reset-password') },
  ];

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            {showNameColumn && <TableCell>{t('name')}</TableCell>}
            <TableCell>{t('emailAddress')}</TableCell>
            <TableCell>{t('role')}</TableCell>
            {onAction && <TableCell>{t('global:actions')}</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {team.map((row, index) => (
            <TableRow key={row.id || index} hover className={index % 2 === 0 ? classes.even : classes.odd}>
              {showNameColumn && (
                <TableCell>
                  {row.firstName ? `${row.firstName} ${row.lastName}` : ''}
                </TableCell>
              )}
              <TableCell>{row.emailAddress}</TableCell>
              <TableCell>{row.role}</TableCell>
              {onAction && (
                <TableCell align="left">
                  {(() => {
                    const filteredActions = actions.filter(action => {
                      // Don't allow users to delete or reset their own password
                      if (user && row.emailAddress === user.emailAddress) {
                        return false;
                      }
                      return true;
                    });
                  
                    return filteredActions.length > 0 ? (
                      <ActionMenu
                        actions={filteredActions}
                        row={row as unknown as Row}
                        onAction={onAction as (action: Action, row: Row) => void}
                      />
                    ) : null;
                  })()}
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
